<template>
    <div class="min-h-screen bg-gradient-to-br from-[#e3f0fa] to-[#c8e0f4] text-gray-800 font-sans">
        <header class="bg-gradient-to-r from-[#1583d4] to-[#0f5fa0] text-white py-8 px-6 text-center shadow-lg">
            <h1 class="text-4xl font-extrabold mb-2">Status do Pagamento</h1>
            <p class="opacity-90 text-lg">Acompanhe o resultado da sua transação</p>
        </header>

        <div class="container mx-auto max-w-2xl py-16 px-6 text-center">
            <div v-if="loading" class="bg-white/90 backdrop-blur-sm p-10 rounded-2xl shadow-lg">
                <p class="text-[#1583d4] text-lg font-semibold">Verificando pagamento...</p>
            </div>

            <div v-else class="bg-white/95 backdrop-blur-sm p-10 rounded-2xl shadow-lg">
                <div v-if="status === 'approved'" class="text-green-600">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-20 h-20 mx-auto mb-4" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                    <h2 class="text-2xl font-bold mb-3">Pagamento Aprovado!</h2>
                    <p class="text-gray-700 mb-6">Seu anúncio será publicado em breve.</p>
                    <router-link to="/" class="px-6 py-3 bg-[#1583d4] text-white rounded-xl hover:bg-[#0f5fa0]">Voltar
                        ao Início</router-link>
                </div>

                <div v-else-if="['pending', 'in_process', 'payment_required'].includes(status)" class="text-yellow-600">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-20 h-20 mx-auto mb-4" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <h2 class="text-2xl font-bold mb-3">Pagamento Pendente/Em Processamento</h2>
                    <!--<p class="text-gray-700 mb-6">Assim que for confirmado, seu anúncio será ativado automaticamente.</p>-->
                    <router-link to="/" class="px-6 py-3 bg-[#1583d4] text-white rounded-xl hover:bg-[#0f5fa0]">Voltar
                        ao Início</router-link>
                </div>

                <div v-else class="text-red-600">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-20 h-20 mx-auto mb-4" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    <h2 class="text-2xl font-bold mb-3">Pagamento Recusado/Inválido</h2>
                    <p class="text-gray-700 mb-6">Ocorreu um problema definitivo com a transação. Tente novamente mais
                        tarde.</p>
                    <router-link to="/" class="px-6 py-3 bg-[#1583d4] text-white rounded-xl hover:bg-[#0f5fa0]">Voltar
                        ao Início</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import api from '@/services/api'
import { useStore } from "vuex"


const store = useStore();
const loading = ref(true)
const status = ref(null)

onMounted(async () => {
    const params = new URLSearchParams(window.location.search)
    const externalReference = params.get('external_reference')
    const hash = params.get('hash')
    const paymentStatus = params.get('collection_status')

    // Se o Mercado Pago já enviou o status na URL
    /*if (paymentStatus && paymentStatus !== 'null') {
        status.value = paymentStatus
        loading.value = false
        return
    }*/

    // Se não, consulta o status real via API
    if (externalReference) {
        try {
            const { data } = await api.get(`/payment/status/${externalReference}/${hash}`);
            status.value = data.advertisement.payments[0].status || 'error';

            //await await store.dispatch('saveAdvertisementToLocalStorage', data.advertisement);
        } catch {
            status.value = 'error'
        } finally {
            loading.value = false
        }
    } else {
        status.value = 'error'
        loading.value = false
    }
})

</script>

<style scoped>
.container {
    animation: fadeIn 0.6s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
